import React from 'react';
import {ContainerFileDinhKem} from 'components/upload';
import { connect } from 'react-redux';
import {
  DropDownChonKetQuaThucHien,
  DropDownMulipleUse
} from 'components/tt-forms';
import moment from 'moment';
import { GiaiQuyetDonThu } from 'api';
import { Toastr } from 'modules/toastr';
import { Link, browserHistory } from 'react-router';
import { ShowIf, ShowIfCheck } from 'components/utils';
import { msg } from 'constants/message';
import ConfirmDialog from './ConfirmDialog.jsx';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import { Input, InputNumber, Text, TextMessage } from 'components/tt-forms/common';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class CanBoNhanYeuCauTheoDoiThucHien extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state={
      dataDetail: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      dataCoQuanTheoDoi: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],

      id: this.props.id,
      loaiDon: this.props.loaiDon,
      nextState: '',
      khoiTo : false,
      openDialog:false,
      soVuBiKhoiTo : 0,
      soDoiTuongBiKhoiTo : 0,
      hinhThucTheoDoi : '',
      coQuanTheoDoi : '',
      ketQuaThucHienTheoDoi : '',
      ketQuaThucHienKhac : '',
      tienPhaiThuNhaNuoc : 0,
      datPhaiThuNhaNuoc : 0,
      tienDaThuNhaNuoc : 0,
      datDaThuNhaNuoc : 0,
      tienPhaiTraCongDan : 0,
      datPhaiTraCongDan : 0,
      tienDaTraCongDan : 0,
      datDaTraCongDan : 0,
    }
  }

  componentDidMount() {
    this.getCoQuanTheoDoiEnumn();
    if(this.props.dataNextStates && this.props.dataNextStates.length > 0) {
      this.checkOnlyState(this.props.dataNextStates);
    }
    this.getDetail(this.state.thongTinGiaiQuyetDonId);
    if (window.debug) {
      console.log('handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/CanBoNhanYeuCauTheoDoiThucHien');
    }
  }

  getDetail(id) {
    if (typeof id != 'undefined') {
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({id:id}).then(res => {
        if (res.data) {
          this.setState({
            dataDetail: res.data,
            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,
            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',
            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,
            showFile: false
          },() => {
            this.checkFileDinhKem();
            if(this.props.dataNextStates && this.props.dataNextStates.length > 0) {
              this.checkOnlyState(this.props.dataNextStates);
            }
          })
        }
      })
    }
  }

  checkFileDinhKem() {
    let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let dataView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let listTaiLieuVanThuGiaiQuyetDon = data.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataDetail.ngayChuyenTheoDoiThucHien), 'show');
    })

    let listTaiLieuVanThuGiaiQuyetDonView = dataView.filter(state => {
      return this.compareDate(new Date(this.state.dataDetail.ngayChuyenTheoDoiThucHien), new Date(state.ngayTao), 'show');
    })
    this.setState({
      listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
      listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView
    } , () => {
      this.setState({
        showFile: true
      })
    })
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime >= secondTime && type == 'show') {
      return true
    } else {
      return false
    }
  }

  checkOnlyState(dataNextStates) {
    this.setState({
      nextState: dataNextStates[0].type
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.id,
      loaiDon: nextProps.loaiDon
    })
    if(this.props.dataNextStates != nextProps.dataNextStates && nextProps.dataNextStates.length > 0) {
      this.checkOnlyState(nextProps.dataNextStates);
    }
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        })
      }
    })
  }

  onClickClose() {
    browserHistory.goBack();
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
    this.props.handleChangeData();
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    });
    if (name =='giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    if (!e) {

    }
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    });
    this.handleKetThuc();
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataDetail;
    let params = getParams(dataGiaiQuyetDon, this.state.id);

    if(params.giaoCoQuanDieuTra && this.state.khoiTo) {
      params.khoiTo = true;
      params.soVuBiKhoiTo = Number(this.state.soVuBiKhoiTo);
      params.soDoiTuongBiKhoiTo = Number(this.state.soDoiTuongBiKhoiTo);
    } else {
      params.khoiTo = false;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;
    }

    params.theoDoiThucHien = true;
    params.hinhThucTheoDoi = this.state.hinhThucTheoDoi ? this.state.hinhThucTheoDoi : null;
    if (this.state.coQuanTheoDoi && this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI') {
      params.coQuanTheoDoi = this.state.coQuanTheoDoi ? this.state.coQuanTheoDoi : null;
    } else {
      params.coQuanTheoDoi = null;
    }
    params.ketQuaThucHienTheoDoi = this.state.ketQuaThucHienTheoDoi ? this.state.ketQuaThucHienTheoDoi : null;
    params.ketQuaThucHienKhac = this.state.ketQuaThucHienKhac ? this.state.ketQuaThucHienKhac : '';

    params.tienPhaiThuNhaNuoc = this.state.tienPhaiThuNhaNuoc ? Number(this.state.tienPhaiThuNhaNuoc) : 0;
    params.datPhaiThuNhaNuoc = this.state.datPhaiThuNhaNuoc ? Number(this.state.datPhaiThuNhaNuoc) : 0;
    params.tienPhaiTraCongDan = this.state.tienPhaiTraCongDan ? Number(this.state.tienPhaiTraCongDan) : 0;
    params.datPhaiTraCongDan = this.state.datPhaiTraCongDan ? Number(this.state.datPhaiTraCongDan) : 0;

    params.tienDaThuNhaNuoc = this.state.tienDaThuNhaNuoc ? Number(this.state.tienDaThuNhaNuoc) : 0;
    params.datDaThuNhaNuoc = this.state.datDaThuNhaNuoc ? Number(this.state.datDaThuNhaNuoc) : 0;
    params.tienDaTraCongDan = this.state.tienDaTraCongDan ? Number(this.state.tienDaTraCongDan) : 0;
    params.datDaTraCongDan = this.state.datDaTraCongDan ? Number(this.state.datDaTraCongDan) : 0;

    return params;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    })
    return pass;
  }

  handleKetThuc() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });

      let dataFileDinhKem = [...this.state.dataFileDinhKem];
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let _params = this.getParams();
      let params = {};
      if (this.props.tuGiaiQuyet == true) {
        params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.props.thongTinGiaiQuyetDonId)
          },
          actionType: 'LANH_DAO_TU_TDTH'
        }
      } else {
        let selectedState = this.props.dataNextStates.filter(state => {
            return state.type == this.state.nextState
        });
        params = {
          thongTinGiaiQuyetDon: {
            id: Number(this.props.thongTinGiaiQuyetDonId),
          },
          nextState: {
            id: Number(selectedState[0].stateId),
          }
        }
      }
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            if (this.props.tuGiaiQuyet == true) {
              this.postGiaiQuyetDon(params, 'gqdLuuHoSo');
            } else {
              this.updateGiaiQuyetDon(_params, params, 'gqdLuuHoSo');
            }
          });
        });
      });
    }
  }

  handleSave() {
    this.setState({
      btnLoading: true,
      btnSaveLoading: true
    });

    let dataFileDinhKem = [...this.state.dataFileDinhKem];
    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(this.state.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            don: {
              id: Number(this.state.id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: loaiTepDinhKem,
            loaiQuyTrinh: loaiQuyTrinh,
            buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
            required: item.required,
            typeRequired: 'DON_VI_THEO_DOI_THUC_HIEN'
          };
        }
      });
    }

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }

    let params = this.getParams();
    this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
      this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
        this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
          this.saveGiaiQuyetDon(params, 'gqdLuu');
        });
      });
    });
  }

  updateGiaiQuyetDon(params, _params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.props.thongTinGiaiQuyetDonId},params).then(res => {
      this.postGiaiQuyetDon(_params, message);
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.props.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.postGiaiQuyetDon.request('', params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.giaiQuyetDon, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  onFileChange(data, type) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    this.setState ({
      dataFileDinhKem: data
    });

    this.props.handleChangeData();

  }

   // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  render() {
    let DataDetail = this.state.dataDetail;

    let ketLuanNoiDungKhieuNai = this.props.dataKetLuanNoiDungKhieuNai.filter(state => {
      return state.giaTri == DataDetail.ketLuanNoiDungKhieuNai
    });

    let lb1 = this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block container-filedinhkem">
        <div className="wrap-big-line pt15"/>
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <h3 className="txt-upper title-14 mt0 mb15 pl5 pr5">Báo cáo kết quả xác minh{lb2}</h3>

            <ShowIf condition={DataDetail.huongThuLyGiaiQuyet != 'TU_TTXM'}>
              <div className="col-100 mb15 no-gutter">
                <Text className="col-25 mb10" label={"Đơn vị "+lb1+":"} value={DataDetail.donViThamTraXacMinhInfo ? DataDetail.donViThamTraXacMinhInfo.ten : ''}/>
                <Text className="col-25 mb10" red={true} label="Thời gian báo cáo kết quả:" value={DataDetail.ngayHetHanTTXM ? moment(DataDetail.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
                <Text className="col-25 mb10" label="Ngày báo cáo kết quả:" value={DataDetail.ngayTraBaoCaoTTXM ? moment(DataDetail.ngayTraBaoCaoTTXM).format('DD/MM/YYYY') : ''}/>
                <TextMessage className='col-100' label='Ý kiến xử lý:' value={DataDetail.noiDung ? DataDetail.noiDung : ''}/>
              </div>
            </ShowIf>

            <ShowIf condition={this.state.loaiDon == 'DON_TO_CAO' && DataDetail.giaHanGiaiQuyet}>
              <div>
                <div className="col-100">
                  <h3 className="text-12 txt-upper txt-bold mb10 mt0">Gia hạn xác minh nội dung tố cáo:</h3>
                </div>
                <Text className="col-25 mb15" label="Số quyết định gia hạn:" value={DataDetail.soQuyetDinhGiaHanGiaiQuyet ? DataDetail.soQuyetDinhGiaHanGiaiQuyet : ''}/>
                <Text className="col-25 mb15" label="Ngày ra quyết định:" value={DataDetail.ngayRaQuyetDinhGiaHanGiaiQuyet ? moment(DataDetail.ngayRaQuyetDinhGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                <Text className="col-25 mb15" red={true} label="Gia hạn giải quyết đến ngày:" value={DataDetail.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(DataDetail.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                <TextMessage className="col-100" label="Lý do gia hạn:" value={DataDetail.lyDoGiaHanGiaiQuyet ? DataDetail.lyDoGiaHanGiaiQuyet : ''}/>
              </div>
            </ShowIf>

            <ShowIf condition={DataDetail.doiThoai == true && this.state.loaiDon == 'DON_KHIEU_NAI'}>
              <div>
                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15">Đối thoại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Thời gian đối thoại:" value={DataDetail.thoiGianDoiThoai ? moment(DataDetail.thoiGianDoiThoai).format('DD/MM/YYYY') : ''}/>
                      <Text className="col-75 mb10" label="Địa điểm:" value={DataDetail.diaDiemDoiThoai ? DataDetail.diaDiemDoiThoai : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Nội dung, kết quả đối thoại:" value={DataDetail.noiDungDoiThoai ? DataDetail.noiDungDoiThoai : ''}/>
                    </div>
                  </div>
                </div>

                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15">Giao dự thảo quyết định giải quyết khiếu nại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Thời gian trình dự thảo:" red={true} value={this.props && DataDetail.ngayHetHanGiaoLapDuThao ? moment(DataDetail.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Ý kiến xử lý:" value={this.props && DataDetail.noiDungGiaoLapDuThao ? DataDetail.noiDungGiaoLapDuThao : ''}/>
                    </div>
                  </div>
                </div>

                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>

                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15"> Dự thảo quyết định giải quyết khiếu nại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Ngày trình dự thảo:" value={DataDetail.ngayKetThucGiaoLapDuThao ? moment(DataDetail.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Tóm tắt nội dung kết quả đối thoại:" value={DataDetail.noiDungKetLuanDuThao ? DataDetail.noiDungKetLuanDuThao : ''}/>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>
          </div>
        </div>
        <div className="row pl15 pr15">
          <div className="wrap-big-line pt5 pb20">
            <span className="big-border"></span>
          </div>
          <div className="col-100 mt5 no-gutter">
            <h2 className="title-14 mb10">Thông tin giải quyết</h2>
          </div>
          <ShowIf condition={DataDetail.ketQuaXLDGiaiQuyet == 'DOI_THOAI'}>
            <div className="col-100 no-gutter pt5 pb15">
              <span className="line-border"></span>
            </div>
            <div className="col-100 no-gutter">
              <div className="col-100 no-gutter mt5 pb5">
                <h2 className="title-12 mb15">Đối thoại</h2>
                <div className="row pl10 pr10">
                  <Text className="col-25 mb10" label="Thời gian đối thoại:" value={DataDetail.thoiGianDoiThoai ? moment(DataDetail.thoiGianDoiThoai).format('DD/MM/YYYY') : ''}/>
                  <Text className="col-75 mb10" label="Địa điểm:" value={DataDetail.diaDiemDoiThoai}/>
                  <TextMessage className='col-100' label='Nội dung, kết quả đối thoại:' value={DataDetail.noiDungDoiThoai ? DataDetail.noiDungDoiThoai : ''}/>
                </div>
              </div>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
              <div className="col-100 no-gutter mt5 pb5">
                <h2 className="title-12 mb15">Giao dự thảo quyết định giải quyết khiếu nại</h2>
                <div className="row pl10 pr10">
                  <Text className="col-25 mb10" red={true} label="Thời gian trình dự thảo:" value={DataDetail.ngayHetHanGiaoLapDuThao ? moment(DataDetail.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                  <TextMessage className='col-100' label='Ý kiến xử lý:' value={DataDetail.noiDungGiaoLapDuThao ? DataDetail.noiDungGiaoLapDuThao : ''}/>
                </div>
              </div>
            </div>
          </ShowIf>

          <div className="col-100 no-gutter pt5 pb15">
            <span className="line-border"></span>
          </div>
          <ShowIf condition={this.state.loaiDon == 'DON_TO_CAO'}>
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Quyết định giải quyết tố cáo</h3>
          </ShowIf>
          <ShowIf condition={this.state.loaiDon == 'DON_KHIEU_NAI'}>
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Quyết định giải quyết khiếu nại</h3>
          </ShowIf>
          <ShowIf condition={this.state.loaiDon != 'DON_TO_CAO' && this.state.loaiDon != 'DON_KHIEU_NAI'}>
            <h3 className="txt-upper col-100 no-gutter title-12 mt0 mb15">Văn bản giải quyết kiến nghị, phản ánh</h3>
          </ShowIf>

          <div className="row pl10 pr10 mb15">
            <Text className="col-25 mb0-18" label="Số vụ:" value={String(DataDetail.soVuGiaiQuyetKhieuNai)}/>
            <ShowIf condition={this.state.loaiDon == 'DON_KHIEU_NAI'}>
              <Text label="Kết luận nội dung khiếu nại:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''}/>
            </ShowIf>
            <ShowIf condition={this.state.loaiDon == 'DON_TO_CAO'}>
              <Text label="Kết luận nội dung tố cáo:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''}/>
            </ShowIf>
            <ShowIf condition={this.state.loaiDon != 'DON_TO_CAO' && this.state.loaiDon != 'DON_KHIEU_NAI'}>
              <Text label="Kết luận nội dung kiến nghị phản ánh:" className="col-25" value={ketLuanNoiDungKhieuNai.length > 0 ? ketLuanNoiDungKhieuNai[0].ten : ''}/>
            </ShowIf>
            <Text className="col-25 mb0-18" label="Kết quả khác:" value={DataDetail.ketQuaGiaiQuyetKhac ? DataDetail.ketQuaGiaiQuyetKhac : ''}/>
          </div>

          <div className="row pl10 pr10 mb5">
            <div className="col-50 no-gutter mb20">
              <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
              <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ):" value={String(DataDetail.tienPhaiThuNhaNuocQDGQ)}/>
              <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2):" value={String(DataDetail.datPhaiThuNhaNuocQDGQ)}/>
            </div>
            <div className="col-50 no-gutter mb20">
              <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
              <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ):" value={String(DataDetail.tienPhaiTraCongDanQDGQ)}/>
              <Text className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2):" value={String(DataDetail.datPhaiTraCongDanQDGQ)}/>
            </div>
            <div className="col-100 no-gutter">
              <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
              <Text className="col-25 mb0-18" type="sdt" label="Tổng số người:" value={String(DataDetail.tongSoNguoiXuLyHanhChinh)}/>
              <Text className="col-25 mb0-18" type="sdt" label="Số người đã bị xử lý:" value={String(DataDetail.soNguoiDaBiXuLyHanhChinh)}/>
              <Text className="col-25 mb0-18" label="Số người được trả lại quyền lợi:" value={String(DataDetail.soNguoiDuocTraLaiQuyenLoi)}/>
            </div>
          </div>
          <div className="wrap-big-line pt5 pb15">
            <span className="big-border"></span>
          </div>
          <div className="col-100 no-gutter mt5">
            <h2 className="title-14 mb15">Theo dõi thực hiện</h2>
          </div>
          <div className="col-100 no-gutter pt5 pb15">
            <span className="line-border"></span>
          </div>
          <ShowIf condition={DataDetail.giaoCoQuanDieuTra}>
            <div className="col-100 no-gutter">
              <div className="col-100 no-gutter mt5 pb5">
                <h2 className="title-12 mb15">Chuyển cơ quan điều tra(Nếu có)</h2>
                <div className="row pl10 pr10">
                  <Text className="col-25 mb0-18" label="Tên cơ quan:" value={DataDetail.coQuanDieuTraInfo ? DataDetail.coQuanDieuTraInfo.ten : ''}/>
                  <Text className="col-25 mb0-18" label="Số vụ:" value={String(DataDetail.soVuGiaoCoQuanDieuTra)}/>
                  <Text className="col-25 mb0-18" label="Số đối tượng:" value={String(DataDetail.soDoiTuongGiaoCoQuanDieuTra)}/>
                </div>
              </div>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
            </div>
          </ShowIf>

          <ShowIf condition={DataDetail.giaoCoQuanDieuTra}>
            <div className="col-100 no-gutter">
              <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                <div className="col-100 no-gutter mt5 pb20">
                  <h2 className="title-12 mb15">Khởi tố</h2>
                  <div className="row pl10 pr10">
                    <div className="col-50 no-gutter">
                      <InputNumber className="col-50 mb0-18" name="soVuBiKhoiTo" label="Số vụ" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                      <InputNumber className="col-50 mb0-18" name="soDoiTuongBiKhoiTo" label="Số đối tượng" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255}/>
                    </div>
                  </div>
                </div>
              </ShowIfCheck>
              <div className="col-100 no-gutter pt5 pb15">
                <span className="line-border"></span>
              </div>
            </div>
          </ShowIf>

          <div className="col-100 no-gutter">
            <div className="col-100 no-gutter mt5 pb20">
              <h2 className="title-12 mb15">Nội dung Theo dõi thực hiện</h2>
              <div className="row pl10 pr10 mb20">
                <ShowIf condition={this.state.hinhThucTheoDoi == 'GIAO_CO_QUAN_KHAC_THEO_DOI'}>
                  <DropDownMulipleUse className="col-25 mb0-18" label="Cơ quan theo dõi" bindValidator={this} selectedValue={this.state.coQuanTheoDoi} onChange={this.onChange.bind(this, 'coQuanTheoDoi')} name='coQuanTheoDoi' data={this.state.dataCoQuanTheoDoi} keyName='giaTri' valueName='ten'/>
                </ShowIf>
              </div>
              <div className="row pl10 pr10 mb20">
                <DropDownChonKetQuaThucHien className="col-25 mb0-18" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.ketQuaThucHienTheoDoi} onChange={this.onChange.bind(this, 'ketQuaThucHienTheoDoi')}/>
                <Input className="col-25 mb0-18" label="Kết quả thực hiện khác" value={this.state.ketQuaThucHienKhac} onChange={this.onChange.bind(this, 'ketQuaThucHienKhac')} name='ketQuaThucHienKhac'/>
              </div>
              <div className="row pl10 pr10">
                <div className="col-100 no-gutter mb20">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                  <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuoc')} name="tienPhaiThuTheoDoiThucHien"/>
                  <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuoc} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuoc')} name="datPhaiThuTheoDoiThucHien"/>
                  <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu tiền (đ)" value={this.state.tienDaThuNhaNuoc} onChange={this.onChange.bind(this, 'tienDaThuNhaNuoc')} name="tienDaThuTheoDoiThucHien"/>
                  <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã thu đất (m2)" value={this.state.datDaThuNhaNuoc} onChange={this.onChange.bind(this, 'datDaThuNhaNuoc')} name="datDaThuTheoDoiThucHien"/>
                </div>
                <div className="col-100 no-gutter">
                  <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                  <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDan} onChange={this.onChange.bind(this, 'tienPhaiTraCongDan')} name="tienPhaiTraTheoDoiThucHien"/>
                  <Input className="col-25 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDan} onChange={this.onChange.bind(this, 'datPhaiTraCongDan')} name="datPhaiTraTheoDoiThucHien"/>
                  <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả tiền (đ)" value={this.state.tienDaTraCongDan} onChange={this.onChange.bind(this, 'tienDaTraCongDan')} name="tienDaTraTheoDoiThucHien"/>
                  <Input className="col-25 mb0-18" type="sdt" align="right" label="Đã trả đất (m2)" value={this.state.datDaTraCongDan} onChange={this.onChange.bind(this, 'datDaTraCongDan')} name="datDaTraTheoDoiThucHien"/>
                </div>
              </div>
            </div>
          </div>
          <ShowIf condition={this.state.showFile}>
            <div className="col-100 pb5 no-gutter">
              <ContainerFileDinhKem
                name="GiaoCQDT"
                label="Danh sách văn bản xử lý"
                bindValidator={this}
                dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView}
                data={this.state.listTaiLieuVanThuGiaiQuyetDon}
                onSave={this.state.onSave}
                onFileRemove={this.onFileRemove.bind(this)}
                onFileChange={this.onFileChange.bind(this)}
              />
            </div>
          </ShowIf>
          <ShowIf condition={!DataDetail.boSungThongTin && (DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null)}>
            <div className="col-100 no-gutter">
              <div className="wrap-big-line pt5 pb15">
                <span className="big-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(DataDetail.noiDungBoSungHoSo)}/>
                  </div>
                </div>
              </div>
              <div className="col-100 pb5 no-gutter">
                <ContainerFileDinhKem name="BoSungTT" label="Danh sách văn bản bổ sung" hideDescription={true} dataShow={DataDetail.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
              </div>
            </div>
          </ShowIf>
        </div>
        <div className='col-100 no-gutter'>
          <div className='wrap-gqd-kqt'>
            <ShowIf condition={DataDetail.lanhDaoView != true && !DataDetail.boSungThongTin}>
              <div className="box-bottom gqd-wrap pt35">
                <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'luuHoSo')}><span>Lưu hồ sơ</span></Link>
                <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this)} title="Xác nhận lưu hồ sơ" content="Bạn có muốn lưu hồ sơ này?"/>
              </div>
            </ShowIf>
          </div>
        </div>
      </section>
    );
  }
}

CanBoNhanYeuCauTheoDoiThucHien.defaultProps = {
  boSungThongTin: false,
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  dataDetail: [],
  listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(CanBoNhanYeuCauTheoDoiThucHien);


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/CanBoNhanYeuCauTheoDoiThucHien.jsx